import React, { useState } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import {
  Grid,
  Card,
  Step,
  Stepper,
  StepLabel,
} from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import Header from "layouts/pages/profile/components/Header";
import About from "./about";
import CloudServerConfig from "./configur";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

function getStepContent(stepIndex, handleNext, handleBack, serverType) {
  switch (stepIndex) {
    case 0:
      return <About onNext={handleNext} serverType={serverType} />;
    case 1:
      return <CloudServerConfig serverType={serverType} onBack={handleBack} />;
    default:
      return "Unknown step";
  }
}

function CloudServerWizard({ serverType }) {
  const [activeStep, setActiveStep] = useState(0);
  const { type } = useParams(); // 'windows' oder 'linux'
  
  const steps = ["Übersicht", "Konfiguration"];

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={8}>
            <SoftBox mb={3} p={1}>
              <SoftTypography
                variant="h3"
                textAlign="center"
                fontWeight="bold"
                color="dark"
              >
                UDS {serverType === 'windows' ? 'Windows' : 'Linux'} Cloud Server
              </SoftTypography>
              <SoftTypography
                variant="h5"
                mt={1}
                textAlign="center"
                fontWeight="regular"
                color="text"
              >
                {serverType === 'windows' 
                  ? 'Leistungsstarke Windows-Server in der Cloud für Ihre individuellen Anforderungen.'
                  : 'Flexibel und sicher: Linux-Server für Ihre Projekte in der Cloud.'}
              </SoftTypography>
            </SoftBox>

            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <Card>
              <SoftBox p={2}>
                <SoftBox>
                  {getStepContent(activeStep, handleNext, handleBack, serverType)}
                </SoftBox>
              </SoftBox>
            </Card>
          </Grid>
        </Grid>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

CloudServerWizard.propTypes = {
  serverType: PropTypes.oneOf(['windows', 'linux']).isRequired
};

export default CloudServerWizard;